import { render, staticRenderFns } from "./wovenbrand.vue?vue&type=template&id=6171656e&scoped=true"
import script from "./wovenbrand.vue?vue&type=script&lang=js"
export * from "./wovenbrand.vue?vue&type=script&lang=js"
import style0 from "./wovenbrand.vue?vue&type=style&index=0&id=6171656e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6171656e",
  null
  
)

export default component.exports